import { exactTime, timeAgo } from "@/lib/time";

// "5 minutes ago" with the exact moment on hover. Pure render: the words
// refresh whenever the page re-renders (navigation, new props), which is as
// often as a low-traffic feed needs.
export function TimeAgo({ at, className }: { at: string; className?: string }) {
  return (
    <time dateTime={at} title={exactTime(at)} className={className}>
      {timeAgo(at)}
    </time>
  );
}
